import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { AnalyticsFilterOption } from "../types";
import { queryKeys } from "./queryKeys";

const fetchAnalyticsSupplierOptions = async (): Promise<
  AnalyticsFilterOption[]
> => {
  const { data } = await axios.get("/analytics/filters/suppliers");
  return data;
};

/** Supplier options for the analytics filter bar — `id` is the supplier company id the BE filters on. */
export const useAnalyticsSupplierOptions = () =>
  useQuery<AnalyticsFilterOption[], Error>({
    queryKey: [queryKeys.ANALYTICS_SUPPLIER_OPTIONS],
    queryFn: fetchAnalyticsSupplierOptions,
  });
